import React, { memo } from 'react';

import FileWithProgress from '../types/fileWithProgress';
import UploadedFileListItem from './UploadedFileListItem';
import { UploadedFileList, UploadedFileListTitle, UploadedFileListWrap } from './style';

interface PropsType {
	label?: string;
	files: FileWithProgress[];
	handleDelete: (file: File | string) => void;
}

function UploadedFiles({ label, files, handleDelete }: PropsType) {
	if (!files || files?.length <= 0) return null;
	return (
		<UploadedFileListWrap>
			{label && <UploadedFileListTitle>{label}:</UploadedFileListTitle>}
			<UploadedFileList>
				{files.map((file, index) => (
					<UploadedFileListItem file={file} key={index} handleDelete={handleDelete} />
				))}
			</UploadedFileList>
		</UploadedFileListWrap>
	);
}

export default memo(UploadedFiles);
